import React, { Component } from 'react';
import { Bar, Line } from 'react-chartjs-2';
import Select from 'react-select'
import { Grid, Tabs, Tab } from '@material-ui/core';
import SwipeableTabs from '../../../../commonModules/MUI/SwipeableTabs';

const Months = ['Janvier', 'Fevrier', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Aout', 'Septembre', 'Octobre', 'Novembre', 'Décembre']
let oneDayTS = 24 * 60 * 60 * 1000



class ShopStat extends Component {
    state = { 
        view: "Months",
        customPeriod: 0,
        saleList: [],
        purchaseList: [],
    }
    componentDidMount() {
        this.setState({
            currentShop: this.props.shop
        })
        this.updateList()
    }
    updateList = () => {
        const { shop, SALES, PURCHASES } = this.props;
        const saleList = this.filterShop(shop, SALES)
        const purchaseList = this.filterShop(shop, PURCHASES)
        this.setState({
            saleList,
            purchaseList
        })
        
    }
    filterShop(selectedShop, list){
        let filteredList = Object.values(list).filter( 
            op => ( op.shop_id === selectedShop || selectedShop === "" )
        )
        console.log({filteredList});
        return filteredList
    }



    sortByDate = (list) => {
        list.sort((a, b) => {
            a = new Date(a); // or timePayment ??
            b = new Date(b);
            if (a > b){
                return 1;
            }
            if (a < b){
                return -1;
            }
            return 0;
        });
        
        return list
    }

    sum = (array, prop) => {
        let sum = 0
        array.forEach( item => sum += item[prop] )
        return sum
    }
    sumObj = (array) => { // SALES
        return array.reduce((acc, obj) => {
            let date = new Date(obj.date)
            var key = this.state.view === "Day" ? 
                date.toLocaleDateString('fr-FR') :
                Months[date.getMonth()] + " " + date.getFullYear();
            
            if(!acc[key]){
                acc[key] = 0;
            }
            acc[key] += this.sum(obj.products, "price")
            return acc;
        }, {});
    }
    sumObjP = (array) => { // PURCHASES
        return array.reduce((acc, obj) => {
            let date = new Date(obj.date)
            var key = this.state.view === "Day" ? 
                date.toLocaleDateString('fr-FR') :
                Months[date.getMonth()] + " " + date.getFullYear();
            
            if(!acc[key]){
                acc[key] = 0;
            }
            acc[key] += obj.prix_revient
            return acc;
        }, {});
    }
    countObj = (array, prop) => {
        return array.reduce((acc, obj) => {
            let date = new Date(obj[prop])
            var key = this.state.view === "Day" ? 
                date.toLocaleDateString('fr-FR') :
                Months[date.getMonth()] + " " + date.getFullYear();
            
            if(!acc[key]){
                acc[key] = 0;
            }
            acc[key] ++;
            return acc;
        }, {});
    }
    bg = (sumObj, color) => {
        return Object.keys(sumObj).map( () => color )
    }
    

    
    calcDataS = (list, bgColor) => {
        let dataList = Object.values(list).reverse()
        let dataObject = this.sumObj(dataList, "date")
        let bg = this.bg(dataObject, bgColor)

        console.log('====================================');
        console.log("calcDataS",{dataObject});
        console.log('====================================');

        return dataObject
    }
    calcDataCumul = (list, bgColor) => {
        let dataList = Object.values(list).reverse()
        let dataObject = this.sumObj(dataList, "date")
        let bg = this.bg(dataObject, bgColor)

        console.log('====================================');
        console.log("calcDataCumul",{dataObject});
        console.log('====================================');

        return dataObject
    }
    calcDataC = (list, bgColor) => {
        let dataList = Object.values(list).reverse()
        let dataObject = this.countObj(dataList, "date")
        let bg = this.bg(dataObject, bgColor)

        console.log('====================================');
        console.log("calcDataC",{dataObject});
        console.log('====================================');

        return dataObject
    }

    
    calcDataMerge = (obj1, obj2, orderedDateList) => {
        let dataObject1 = {}
        let dataObject2 = {}
        let cumulData1 = []
        let cumulData2 = []
    
        orderedDateList.map( (date, index) => {
            dataObject1[date] = obj1[date] || 0
            dataObject2[date] = obj2[date] || 0
            
            if (index === 0){
                cumulData1[index] = obj1[date] || 0 
                cumulData2[index] = obj2[date] || 0 
                
            } else {
                cumulData1[index] = ( cumulData1[index - 1] + (obj1[date] || 0) )
                cumulData2[index] = ( cumulData2[index - 1] + (obj2[date] || 0) )
            }
        })

        return {
            dataObject1,
            dataObject2,
            cumulData1,
            cumulData2,
            bg1: this.bg(dataObject1, 'rgba(255, 206, 86, 0.6)'),
            bg2: this.bg(dataObject2, 'rgba(196, 105, 143, 0.6)'),
            bgC1: this.bg(dataObject1, 'rgba(255, 206, 86, 0.6)'),
            bgC2: this.bg(dataObject2, 'rgba(196, 105, 143, 0.6)'),
        }

    }
    

    getData = () => {
        const { shop, SALES, PURCHASES } = this.props;

        const saleList = this.filterShop(shop, SALES)
        const purchaseList = this.filterShop(shop, PURCHASES)

        const filterSales = this.filterList(saleList)
        const filterPurchases = this.filterList(purchaseList)

        let totalList = Object.values(filterSales).concat(Object.values(filterPurchases))
        let orderDates = this.sortByDate(totalList.map(item => item.date))

        let dateList = []
        const firstDay = new Date(orderDates[0]).getTime()

        for( let date = firstDay; date < Date.now(); date += oneDayTS){
            if(this.state.view === "Day"){
                let label = new Date(date).toLocaleDateString('fr-FR')
                !dateList.includes(label) && dateList.push(label)
            } else {
                let label = Months[new Date(date).getMonth()] + " " + new Date(date).getFullYear()
                !dateList.includes(label) && dateList.push(label)
            }
        }


        const salesData = this.calcDataS(filterSales)
        const purchasesData = this.calcDataS(filterPurchases)
        const mergeSum = this.calcDataMerge(salesData, purchasesData, dateList)

        const salesDataCount = this.calcDataC(filterSales)
        const purchasesDataCount = this.calcDataC(filterPurchases)
        const mergeCount = this.calcDataMerge(salesDataCount, purchasesDataCount, dateList)


        const data = {
            labels: Object.keys(mergeSum.dataObject1),
            datasets:[
                {
                    label:"Ventes",
                    data: Object.values(mergeSum.dataObject1),
                    backgroundColor:mergeSum.bg1,
                },
                {
                    label:"Achats",
                    data: Object.values(mergeSum.dataObject2),
                    backgroundColor:mergeSum.bg2,
                },
            ]
        }        
        const data2 = {
            labels: Object.keys(mergeCount.dataObject1),
            datasets:[
                {
                    label:"Ventes",
                    data: Object.values(mergeCount.dataObject1),
                    backgroundColor:mergeCount.bg1,
                },
                {
                    label:"Achats",
                    data: Object.values(mergeCount.dataObject2),
                    backgroundColor:mergeCount.bg2,
                },
            ]
        }
        const data3 = {
            labels: Object.keys(mergeSum.dataObject1),
            datasets:[
                {
                    label:"Ventes",
                    data: Object.values(mergeSum.cumulData1),
                    backgroundColor:mergeSum.bgC1,
                },
                {
                    label:"Achats",
                    data: Object.values(mergeSum.cumulData2),
                    backgroundColor:mergeSum.bgC2,
                },
            ]
        }
        // const data3 = {
        //     labels: Object.keys(mergeCount.cumulData1),
        //     datasets:[
        //         {
        //             label:"Ventes",
        //             data: Object.values(mergeCount.cumulData1),
        //             backgroundColor:mergeCount.bgC1,
        //         },
        //         {
        //             label:"Achats",
        //             data: Object.values(mergeCount.cumulData2),
        //             backgroundColor:mergeCount.bgC2,
        //         },
        //     ]
        // }

        return {
            data,
            data2,
            data3
        }

    }
    filterList = (list) => {
        let newList = {}
        if (this.state.customPeriod !== 0) {
            let dateLimit =  Date.now() - (this.state.customPeriod * oneDayTS)

            Object.values(list).forEach(item => {
                if(new Date(item.date) >= dateLimit){
                    newList[item.id] = item
                }
            })
        } else {
            newList = list
        }
        return newList
    }
    render() {
        // const { SALES, PURCHASES } = this.props;
        let infos = this.getData()
        
        return (
            <div>
                {/* <ul 
                    className="tab-nav text-center" role="tablist" tabIndex={this.state.tabIndex}style={{ overflow: "auto" }}
                >
                    {/* <li 
                        onClick={ ()=> this.setState({view:"Year"})} 
                        className={this.state.view === "Year" ? "active" : ""} 
                        >
                        <a href="#" >Année</a>
                    </li>
                    <li 
                        onClick={ ()=> this.setState({view:"Months", customPeriod: 0})} 
                        className={this.state.view === "Months" ? "active" : ""} 
                        >
                        <a href="#" >Mois</a>
                    </li>
                    <li 
                        onClick={ ()=> this.setState({view:"Day"})} 
                        className={this.state.view === "Day" ? "active" : ""} 
                        >
                        <a href="#" >Jour</a>
                    </li>
                </ul> */}
                <Tabs
                    value={this.state.view}
                    onChange={(e, tab) => this.setState({ view: tab})}
                    indicatorColor="secondary"
                    textColor="secondary"
                    variant="scrollable"
                    scrollButtons="auto"
                >
                    <Tab value="Months" label="Mois" />
                    <Tab value="Day" label="Jour" />
                </Tabs>

                {this.state.view === "Day" && 
                    <div >
                        <h4>Periode</h4>
                        <label className="radio radio-inline m-r-20 m-b-10 m-l-10">
                            <input type="radio" name="aboRadio" 
                                checked= { (this.state.customPeriod === 0 ? true : false)}
                                onChange={() => this.setState({ customPeriod: 0})} />
                            <i className="input-helper"></i>
                            <span>Toutes </span>
                        </label>
                        <label className="radio radio-inline m-r-20 m-b-10 m-l-10">
                            <input type="radio" name="aboRadio" 
                                checked= { (this.state.customPeriod === 10 ? true : false)}
                                onChange={() => this.setState({ customPeriod: 10})} />
                            <i className="input-helper"></i>
                            <span>10 derniers Jours</span>
                        </label>
                        
                        <label className="radio radio-inline m-r-20 m-b-10">
                            <input type="radio" name="customPeriod" 
                                checked= { (this.state.customPeriod === 30 ? true : false)}
                                onChange={() => this.setState({ customPeriod: 30})} />
                            <i className="input-helper"></i>
                            <span>30 derniers Jours</span>
                        </label>

                        <label className="radio radio-inline m-r-20 m-b-10">
                            <input type="radio" name="customPeriod" 
                                checked= { (this.state.customPeriod === 60 ? true : false)}
                                onChange={() => this.setState({ customPeriod: 60})} />
                            <i className="input-helper"></i>
                            <span>2 derniers mois</span>
                        </label>
                        <label className="radio radio-inline m-r-20 m-b-10">
                            <input type="radio" name="customPeriod" 
                                checked= { (this.state.customPeriod === 90 ? true : false)}
                                onChange={() => this.setState({ customPeriod: 90})} />
                            <i className="input-helper"></i>
                            <span>3 derniers mois</span>
                        </label>
                        <label className="radio radio-inline m-r-20 m-b-10">
                            <input type="radio" name="customPeriod" 
                                checked= { (this.state.customPeriod === 180 ? true : false)}
                                onChange={() => this.setState({ customPeriod: 180})} />
                            <i className="input-helper"></i>
                            <span>6 derniers mois</span>
                        </label>
                    </div>
                }
                <Grid container spacing={2} >
                    <Grid item lg={6} xs={12}>
                        <div className="chart">
                            <Bar
                                data={infos.data}
                                options={{
                                    title:{
                                        display: true,
                                        text:`Volumes total des opérations (FCFA)`,
                                        fontSize:19
                                    },
                                }}
                            />
                        </div>
                    </Grid>
                    <Grid item lg={6} xs={12}>
                        <div className="chart">
                            <Bar
                                data={infos.data2}
                                options={{
                                    title:{
                                        display: true,
                                        text:`Volumes total des opérations (nombre d'opérations)`,
                                        fontSize:19
                                    },
                                }}
                            />
                        </div>
                    </Grid>
                    <div item lg={6} xs={12}>
                        <div className="chart">
                            <Line
                                data={infos.data3}
                                options={{
                                    title:{
                                        display: true,
                                        text:`Cumul des opérations (FCFA)`,
                                        fontSize:19
                                    },
                                }}
                            />
                        </div>
                    </div>
                    <div item lg={6} xs={12}></div>
                </Grid>
            </div>
        );
    }
}

export default ShopStat;